// LOCAL--;
// export const SERVER_URL = "http://localhost:4000/";
// export const AXIOS_BASE_URL = "http://localhost:4000/api";

// LIVE--
export const SERVER_URL = "https://expressoneltd.com/hr/";
export const AXIOS_BASE_URL = "https://expressoneltd.com/api";
